module.exports = __webpack_public_path__ + "static/lframe-determine-rate-d71162da542c320a27d53ffd9d0a47ea.png";